/* eslint-disable no-undef */

const EXAMPLE_TRANSACTION_ID = 'example';

export function getViewportWidth() {
    return Math.max(document.documentElement.clientWidth, window.innerWidth);
}

export const isInBrowser = () => typeof window !== 'undefined';

const CONFIG_PARAM_TO_URL_KEY = {
    transaction_id: 'package',
    signer_id: 'signer',
    status: 'status'
};

export const getCustomHandOverUrl = ({
    handOverUrl,
    status,
    transactionId,
    signerId,
    parameters
}) => {
    if (!handOverUrl) {
        return null;
    }

    const [url, query] = handOverUrl.split('?');
    const params = new URLSearchParams(query);
    const paramsObject = {
        status,
        package: transactionId,
        signer: signerId
    };

    const configuredKeys = (parameters || []).map(
        (parameter) => CONFIG_PARAM_TO_URL_KEY[parameter.toLowerCase()] || parameter.toLowerCase()
    );
    Object.keys(paramsObject)
        .filter((key) => configuredKeys.includes(key))
        .forEach((key) => params.append(key, paramsObject[key]));
    const paramsString = params.toString();

    return paramsString.length ? `${url}?${paramsString}` : url;
};

export const saveToTempStorage = ({value, key}) => {
    if (!window.tempStore) {
        window.tempStore = {};
    }
    window.tempStore[key] = value;
};

export const getIsExampleTransactionID = (id) => id === EXAMPLE_TRANSACTION_ID;
